import React from 'react';
import {ButtonGroup, Col, Container, Navbar } from 'react-bootstrap';
import PVIndicator from './PVIndicator';
import DiscountSelector from './DiscountSelector';
import CurrentRegionButton from './CurrentRegionButton';
import classNames from 'classnames';
import useWindowIsScrolled from '../../hooks/useWindowIsScrolled';
import ClearSkusSelectedButton from './ClearSkusSelectedButton';
import CalculateButton from './CalculateButton';

export const MainNavbar = () => {
    const windowIsScrolled = useWindowIsScrolled();

    return <div
        className={classNames(
            'sticky-top',
            windowIsScrolled ? 'shadow' : 'shadow-none'
        )}
    >
        <Navbar variant="dark">
            <Container>
                <Col>
                    <Navbar.Text>
                        <PVIndicator />
                    </Navbar.Text>
                </Col>
                <Col className="text-end">
                    <ButtonGroup>
                        <ClearSkusSelectedButton />
                        <CalculateButton />
                    </ButtonGroup>
                </Col>
            </Container>
        </Navbar>
        <Navbar variant="light">
            <Container>
                <Col>
                    <Navbar.Text>
                        <CurrentRegionButton />
                    </Navbar.Text>
                </Col>
                <Col className="text-end">
                    <DiscountSelector />
                </Col>
            </Container>
        </Navbar>
    </div>;
}

export default MainNavbar;
